import { InferGetStaticPropsType } from 'next';
import { getStaticProps } from '@/src/pages/knowledge/blog/[slug]';

import { KnowHowForm } from '@components';

type Post = InferGetStaticPropsType<typeof getStaticProps>['post'];
export const splitByInsertions = (
  src: string,
  post: Post
): (string | React.ComponentType)[] =>
  src
    .split('<!-- お役立ち資料フォーム -->')
    .flatMap((e, i, a) =>
      i < a.length - 1
        ? [
            e,
            () => (
              <KnowHowForm
                category={post.hnavi?.hnaviMainCategory || undefined}
              />
            ),
          ]
        : [e]
    );
